import { RootCauseAddingVariablesGraphGroupResult } from 'libs/end-to-end/src/root-cause-analysis';
import { RootCauseGroupResult } from 'libs/end-to-end/src/root-cause-analysis';
import { RootCauseAddingVariablesGraphPlotData } from 'libs/end-to-end/src/root-cause-analysis';
import { RootCauseOaxacaBetaGraphGroupDataArray } from 'libs/end-to-end/src/root-cause-analysis';
import { RootCauseOaxacaBetaGraphGroupPlotData } from 'libs/end-to-end/src/root-cause-analysis';
import { Nullable } from 'libs/end-to-end/src/ui-types';

export interface OaxacaCategoriesName {
  referenceCategory: string;
  treatmentCategory: string;
}

const getOaxacaBetaCategories = (
  result: RootCauseAddingVariablesGraphGroupResult,
): OaxacaCategoriesName | undefined => {
  const plotData = RootCauseOaxacaBetaGraphGroupPlotData.parse(result.plotData);

  const data = RootCauseOaxacaBetaGraphGroupDataArray.parse(plotData.data);

  if (data.length > 0) {
    return {
      referenceCategory: data[0].referenceCategoryBarPair.name,
      treatmentCategory: data[0].treatmentCategoryBarPair.name,
    };
  }
};

const getOaxacaXCategories = (
  result: RootCauseAddingVariablesGraphGroupResult,
): OaxacaCategoriesName | undefined => {
  const plotData = RootCauseAddingVariablesGraphPlotData.parse(result.plotData);

  return {
    referenceCategory: plotData.referenceDimensionLevelColumnValue,
    treatmentCategory: plotData.treatmentDimensionLevelColumnValue,
  };
};

/**
 * Returns a dictionary with the name of the reference category and one
 * treatment category on a oaxaca chart. Oaxaca beta bar charts can have more
 * than one treatment category but only one is going to be returned.
 */
export const getBarChartCategories = ({
  groupResult,
}: {
  groupResult: Nullable<RootCauseGroupResult>;
}): OaxacaCategoriesName | undefined => {
  const parsedResult =
    RootCauseAddingVariablesGraphGroupResult.safeParse(groupResult);

  if (parsedResult.success && groupResult?.plot_type === 'barChart') {
    switch (groupResult?.decompositionType) {
      case 'Oaxaca Beta':
        return getOaxacaBetaCategories(groupResult);
      case 'Oaxaca X':
      case 'Adding Variables':
        return getOaxacaXCategories(groupResult);
    }
  }
};
